import { render } from "./vue-countTo.vue?vue&type=template&id=70faaf6b"
import script from "./vue-countTo.vue?vue&type=script&lang=js"
export * from "./vue-countTo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__